import { render, staticRenderFns } from "./remove-icon-button.vue?vue&type=template&id=e7b1b7ac"
import script from "./remove-icon-button.vue?vue&type=script&lang=js"
export * from "./remove-icon-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports